import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@orijinworks/frontend-commons';
import { Box } from '@material-ui/core';
import { useSectionTitleStyles } from './SectionTitle.styles';

/**
 * Cerulean overline section heading used across Create Plan sections.
 */
export const SectionTitle = ({ title, suffix, disablePadding }) => {
  const classes = useSectionTitleStyles();
  const rootClassName = disablePadding
    ? `${classes.root} ${classes.rootNoPadding}`
    : classes.root;

  return (
    <Box className={rootClassName}>
      <Typography variant="overlineLarge" className={classes.title}>
        {title}
      </Typography>
      {suffix ? (
        <Typography variant="body1" className={classes.suffix}>
          {suffix}
        </Typography>
      ) : null}
    </Box>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  suffix: PropTypes.string,
  disablePadding: PropTypes.bool,
};

SectionTitle.defaultProps = {
  suffix: undefined,
  disablePadding: false,
};

export default SectionTitle;
